import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { makeApiCall } from '../../services/httpService';
import { BASE_URL } from '../../config';
import toast from 'react-hot-toast';
import DContext from '../../context/DContext';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ContentLoader from '../loader/ContentLoader';
import { Button, Modal } from 'react-bootstrap';
import { useLoadingBar } from 'react-top-loading-bar';

const FlightList = () => {
  const { start, complete } = useLoadingBar({ color: "blue", height: 2 });

  const location = useLocation();

  const { authState, authDispatch, logout } = useContext(DContext);
  const { user } = authState;

  const [loading, setLoading] = useState(false);
  const [flightRes, setFlightRes] = useState({
    paginationInfo: {},
    flights: []
  });

  const [pageValue, setPageValue] = useState(1);
  const [pagingLimit, setPagingLimit] = useState("10");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [flightDetail, setFlightDetail] = useState({
    flightId: "",
    depTime: "",
    arrTime: "",
    depTerminal: "",
    arrTerminal: ""
  });


  useEffect(() => {
    loadFlights();
  }, [pagingLimit, pageValue]);

  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon // 'success' | 'error' | 'warning' | 'info' | 'question'
    })
  }

  const getModule = () => {
    let tempModuleVal = location.pathname.split("/")[1];
    const moduleData = user?.menu_access.find(ele => ele.route_to.includes(tempModuleVal));
    return moduleData;
  }

  const loadFlights = async () => {
    try {
      setLoading(true);
      start();
      let apiUrl = `${BASE_URL}/api/flights?&page=${pageValue}&limit=${pagingLimit}`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        setFlightRes({
          paginationInfo: apiRes.resData?.paginationInfo,
          flights: apiRes.resData?.flights
        })
      } else {
        console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false)
      complete();
    }
  }

  const toggleFlightStatus = async (flightId, flightStatus) => {
    const isConfirmed = window.confirm(`Are you sure you want to ${flightStatus} this flight?`);
    if (isConfirmed) {
      try {
        setLoading(true);
        let bodyPayload = { status: flightStatus };
        let apiUrl = `${BASE_URL}/api/flights/${flightId}`;
        let apiRes = await makeApiCall("DELETE", bodyPayload, apiUrl);
        console.log(apiRes);
        if (apiRes?.statusCode == 200) {
          toast.success(apiRes.message);
        } else {
          console.log(apiRes?.response?.data?.message)
          if (apiRes?.response?.data?.message) {
            showSwal("Error", apiRes?.response?.data?.message, "error")
          } else {
            toast.error(apiRes.message);
          }
        }
      } catch (err) {
        console.log("Fatal Error", err);
        //toast.error("Something Went Wrong...");
        showSwal("Error", "Something went wrong...", "error")
      } finally {
        setLoading(false);
        loadFlights();
      }
    }
  }

  const handleUpdateFlight = (flightArgs) => {
    console.log("---flight args", flightArgs);
    setShow(true);
    setFlightDetail({
      flightId: flightArgs?.id,
      depTime: flightArgs?.departure_time,
      arrTime: flightArgs?.arrival_time,
      depTerminal: flightArgs?.departure_terminal,
      arrTerminal: flightArgs?.arrival_terminal
    });

  }

  const handlePagingLimit = (e) => {
    setPageValue(1);
    setPagingLimit(e.target.value);
  }

  const handlePagination = (pageValueInput) => {
    setPageValue(pageValueInput);
  }

  const handleChange = (e) => {
    setFlightDetail({ ...flightDetail, [e.target.name]: e.target.value });
  }

  const handleSubmit = async (e) => {
    try {
      console.log("final form data", flightDetail);
      setLoading(true);
      e.preventDefault();
      let apiUrl = `${BASE_URL}/api/flights/${flightDetail?.flightId}`;
      let apiRes = await makeApiCall("PATCH", flightDetail, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
        //setFlightDetail(initialFlightDetail);
      } else {
        console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false);
      handleClose();
      loadFlights();
    }
  }


  return (
    <>
      {/* https://airhex.com/airline-logos/ */}
      {/* https://www.iata.org/en/publications/directories/code-search?airline.search=air%20asia */}
      <section className="section dashboard">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="card-title m-0 p-0">Total Records <span>: {flightRes?.paginationInfo?.totalRecords}</span></h5>
                  <Link to="/flight/add" className="btn btn-outline-primary"><i className="bi bi-airplane-fill"></i> Add New Flight Detail</Link>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="top-selling overflow-auto">
                      <div className="pb-0">
                        <div style={{ position: 'relative' }}>
                          {loading && (
                            <div style={{
                              position: 'absolute',
                              top: 0, left: 0,
                              right: 0, bottom: 0,
                              background: 'rgba(255,255,255,0.6)',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              zIndex: 10
                            }}>
                              <ContentLoader loaderType="circleSpin" />
                            </div>
                          )}
                          <div className="table-responsive" style={{ height: "calc(100vh - 370px)" }}>
                            <table className="table table-hover align-middle mb-0">
                              <thead>
                                <tr style={{ background: "#f8f9fe" }}>
                                  {["Flight", "Number", "Departure Airport", "Arrival Airport", "Timing", "Terminal", "Status", "Actions"].map((h, i) => (
                                    <th key={i} style={{
                                      fontSize: "11px", fontWeight: "700", color: "#8a9ab5",
                                      textTransform: "uppercase", letterSpacing: "0.6px",
                                      borderBottom: "2px solid #e8edf5", padding: "10px 12px",
                                      whiteSpace: "nowrap", background: "#f8f9fe"
                                    }}>{h}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  flightRes?.flights?.map((flight, index) => (
                                    <tr
                                      key={flight?.id}
                                      style={{
                                        borderBottom: '1px solid #f0f2f5',
                                        transition: 'background 0.15s',
                                      }}
                                      onMouseEnter={e => e.currentTarget.style.background = '#f8f9ff'}
                                      onMouseLeave={e => e.currentTarget.style.background = index % 2 === 0 ? '#fff' : '#fafbfc'}
                                    >
                                      <td className="ps-3">
                                        <div className="d-flex align-items-center gap-2">
                                          <div
                                            className="rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: 36, height: 36, background: '#e8f0fe', flexShrink: 0 }}
                                          >
                                            <i className="bi bi-airplane-fill text-primary" style={{ fontSize: 14 }}></i>
                                          </div>
                                          <div>
                                            <div className="fw-semibold text-dark" style={{ fontSize: 13 }}>{flight?.flight_name}</div>
                                            <div className="text-muted" style={{ fontSize: 11 }}>{flight?.flight_code}</div>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-flex align-items-center gap-2">
                                          <img
                                            style={{ width: 24, height: 24, objectFit: 'contain', borderRadius: 4 }}
                                            src={`https://images.kiwi.com/airlines/32/${flight?.flight_code}.png`}
                                            alt={flight?.flight_name}
                                            onError={e => { e.target.style.display = 'none'; }}
                                          />
                                          <span className="fw-medium" style={{ fontSize: 13 }}>{flight?.flight_number}</span>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="fw-medium" style={{ fontSize: 13 }}>{flight?.departureAirport?.airport_name}</div>
                                        <div className="text-muted" style={{ fontSize: 11 }}>
                                          <i className="bi bi-geo-alt-fill me-1 text-primary" style={{ fontSize: 10 }}></i>
                                          {flight?.departureAirport?.airport_code},{flight?.departureAirport?.city_name}
                                        </div>
                                      </td>
                                      <td>
                                        <div className="fw-medium" style={{ fontSize: 13 }}>{flight?.arrivalAirport?.airport_name}</div>
                                        <div className="text-muted" style={{ fontSize: 11 }}>
                                          <i className="bi bi-geo-alt-fill me-1 text-danger" style={{ fontSize: 10 }}></i>
                                          {flight?.arrivalAirport?.airport_code},{flight?.arrivalAirport?.city_name}
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-flex align-items-center gap-1" style={{ fontSize: 13 }}>
                                          <span className="badge rounded-pill" style={{ background: '#e8f0fe', color: '#0d6efd', fontWeight: 500 }}>
                                            {flight?.departure_time}
                                          </span>
                                          <i className="bi bi-arrow-right text-muted" style={{ fontSize: 11 }}></i>
                                          <span className="badge rounded-pill" style={{ background: '#fce8e6', color: '#d93025', fontWeight: 500 }}>
                                            {flight?.arrival_time}
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-flex align-items-center gap-1" style={{ fontSize: 13 }}>
                                          <span className="badge" style={{ background: '#f1f3f4', color: '#444', fontWeight: 500 }}>
                                            T{flight?.departure_terminal}
                                          </span>
                                          <i className="bi bi-arrow-right text-muted" style={{ fontSize: 11 }}></i>
                                          <span className="badge" style={{ background: '#f1f3f4', color: '#444', fontWeight: 500 }}>
                                            T{flight?.arrival_terminal}
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        {flight?.status === "active"
                                          ? <span className="badge rounded-pill px-3 py-2" style={{ background: '#d4edda', color: '#155724', fontSize: 11, fontWeight: 600, letterSpacing: 0.3 }}>
                                            <i className="bi bi-check-circle-fill me-1"></i>Active
                                          </span>
                                          : <span className="badge rounded-pill px-3 py-2" style={{ background: '#f8d7da', color: '#721c24', fontSize: 11, fontWeight: 600, letterSpacing: 0.3 }}>
                                            <i className="bi bi-x-circle-fill me-1"></i>Inactive
                                          </span>
                                        }
                                      </td>
                                      <td className="text-center">
                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                          <button
                                            className="btn btn-sm d-flex align-items-center justify-content-center"
                                            onClick={() => handleUpdateFlight(flight)}
                                            title="Edit"
                                            style={{ width: 32, height: 32, borderRadius: 8, background: '#e8f0fe', color: '#0d6efd', border: 'none', padding: 0 }}
                                          >
                                            <i className="bi bi-pencil-fill" style={{ fontSize: 13 }}></i>
                                          </button>
                                          {flight?.status === "active"
                                            ? <button
                                              className="btn btn-sm d-flex align-items-center justify-content-center"
                                              onClick={() => toggleFlightStatus(flight?.id, "inactive")}
                                              title="Deactivate"
                                              style={{ width: 32, height: 32, borderRadius: 8, background: '#fce8e6', color: '#d93025', border: 'none', padding: 0 }}
                                            >
                                              <i className="bi bi-trash-fill" style={{ fontSize: 13 }}></i>
                                            </button>
                                            : <button
                                              className="btn btn-sm d-flex align-items-center justify-content-center"
                                              onClick={() => toggleFlightStatus(flight?.id, "active")}
                                              title="Activate"
                                              style={{ width: 32, height: 32, borderRadius: 8, background: '#d4edda', color: '#155724', border: 'none', padding: 0 }}
                                            >
                                              <i className="bi bi-arrow-counterclockwise" style={{ fontSize: 13 }}></i>
                                            </button>
                                          }
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="table-pagination-without-padding">
                          <div className="dataTables_info d-flex align-items-center" role="status" aria-live="polite">
                            <select class="form-select" id="paginationRows" aria-label="Pagination Rows" onChange={handlePagingLimit}>
                              <option value="10" selected={pagingLimit == "10" ? true : false}>10</option>
                              <option value="20" selected={pagingLimit == "20" ? true : false}>20</option>
                              <option value="50" selected={pagingLimit == "50" ? true : false}>50</option>
                              <option value="100" selected={pagingLimit == "100" ? true : false}>100</option>
                              <option value="500" selected={pagingLimit == "500" ? true : false}>500</option>
                            </select>
                            <div class="text-nowrap ms-2">Records Per Page</div>
                          </div>

                          <div className="dataTables_paginate paging_simple_numbers">
                            <ul className="pagination">
                              <li className={pageValue === 1 ? "paginate_button page-item previous disabled" : "paginate_button page-item previous"}>
                                <Link aria-controls="example4" data-dt-idx="0" tabindex="0" className="page-link" onClick={() => handlePagination(pageValue - 1)}>
                                  <i class="fa-solid fa-angle-left"></i>
                                </Link>
                              </li>
                              {
                                Array.from({ length: flightRes?.paginationInfo?.totalPage }, (_, i) => (
                                  <li className={pageValue == i + 1 ? "paginate_button page-item active" : "paginate_button page-item"} key={i}>
                                    <Link aria-controls="example4" data-dt-idx="1" tabindex="0" className="page-link" onClick={() => handlePagination(i + 1)}>
                                      {i + 1}
                                    </Link>
                                  </li>
                                ))
                              }
                              <li className={pageValue === flightRes?.paginationInfo?.totalPage ? "paginate_button page-item next disabled" : "paginate_button page-item next"} id="example4_next">
                                <Link aria-controls="example4" data-dt-idx="3" tabindex="0" className="page-link" onClick={() => handlePagination(pageValue + 1)}>
                                  <i class="fa-solid fa-angle-right"></i>
                                </Link>
                              </li>

                              {/* disabled button
                              <li className="paginate_button page-item next disabled" id="example4_next">
                                <a aria-controls="example4" data-dt-idx="3" tabindex="0" className="page-link" onclick={() => handlePagination("next")}>
                                  Next
                                </a>
                              </li> */}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal size="lg" show={show} onHide={handleClose}>
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)', borderBottom: 'none' }}>
            <Modal.Title className="d-flex align-items-center gap-2" style={{ color: '#fff', fontSize: 18, fontWeight: 600 }}>
              <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: 36, height: 36, background: 'rgba(255,255,255,0.2)' }}>
                <i className="bi bi-pencil-fill" style={{ fontSize: 15, color: '#fff' }}></i>
              </div>
              Update Flight Info
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '24px', background: '#f8f9ff' }}>
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-semibold text-muted" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    <i className="bi bi-clock-fill me-1 text-primary"></i>Departure Time
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="DepartureTimeInput"
                    placeholder="e.g. 08:30"
                    maxLength={5}
                    name="depTime"
                    value={flightDetail?.depTime || ""}
                    onChange={handleChange}
                    style={{ borderRadius: 10, border: '1.5px solid #dee2e6', padding: '10px 14px', fontSize: 14 }}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold text-muted" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    <i className="bi bi-clock-fill me-1 text-danger"></i>Arrival Time
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="ArrivalTimeInput"
                    placeholder="e.g. 11:45"
                    maxLength={5}
                    name="arrTime"
                    value={flightDetail?.arrTime || ""}
                    onChange={handleChange}
                    style={{ borderRadius: 10, border: '1.5px solid #dee2e6', padding: '10px 14px', fontSize: 14 }}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold text-muted" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    <i className="bi bi-sign-turn-right-fill me-1 text-primary"></i>Departure Terminal
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="DepartureTerminalInput"
                    placeholder="e.g. 1"
                    name="depTerminal"
                    value={flightDetail?.depTerminal || ""}
                    onChange={handleChange}
                    style={{ borderRadius: 10, border: '1.5px solid #dee2e6', padding: '10px 14px', fontSize: 14 }}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold text-muted" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    <i className="bi bi-sign-turn-right-fill me-1 text-danger"></i>Arrival Terminal
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="ArrivalTerminalInput"
                    placeholder="e.g. 2"
                    name="arrTerminal"
                    value={flightDetail?.arrTerminal || ""}
                    onChange={handleChange}
                    style={{ borderRadius: 10, border: '1.5px solid #dee2e6', padding: '10px 14px', fontSize: 14 }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button type="button" onClick={handleClose} className="btn d-flex align-items-center gap-2" style={{ borderRadius: 10, padding: '9px 20px', border: '1.5px solid #dee2e6', background: '#fff', color: '#555', fontWeight: 500, fontSize: 14 }}>
                  <i className="bi bi-x-lg"></i> Cancel
                </button>
                <button type="submit" className="btn d-flex align-items-center gap-2" style={{ borderRadius: 10, padding: '9px 20px', background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)', color: '#fff', border: 'none', fontWeight: 500, fontSize: 14 }}>
                  <i className="bi bi-check-lg"></i> Update Flight
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </section >
    </>
  )
}

export default FlightList;